module.exports = __webpack_public_path__ + "img/a043f3a.png";